import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';

import ProcedureStepTaskListingRenderer from '../procedures/ProcedureStepTaskListingRenderer';

export default class AssayStepTaskListingRenderer extends ProcedureStepTaskListingRenderer<ListingRendererType.ASSAY_STEP_TASK> {
  listingRendererType = ListingRendererType.ASSAY_STEP_TASK;

  constructor() {
    super(ProcessClientOrigin.ASSAYS);
  }
}
